"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _commonReact = require("@devsta/common-react");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ThumbnailAssetSelector(_ref) {
  var assetId = _ref.assetId,
      videoAssetIds = _ref.videoAssetIds,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_commonReact.AssetsSelector, {
    assetIds: assetId ? [assetId] : videoAssetIds
  }, function (assets) {
    var validAsset = assets.find(function (asset) {
      if (asset === null) {
        return false;
      } // If any of the assets are void 0 it means we haven't resolved them yet


      if (!asset) {
        return true;
      }

      var originalFile = (0, _lodash.default)(asset, 'assetFiles.ORIGINAL');

      try {
        var _JSON$parse = JSON.parse(asset.metaData),
            type = _JSON$parse.type;

        return originalFile.status !== 'MISSING' && originalFile.status !== 'TRANSCODE_FAILED' && originalFile.status !== 'ERROR' && (type.includes('video/') || type.includes('image/'));
      } catch (e) {
        return false;
      }
    });
    return children(validAsset);
  });
}

var _default = /*#__PURE__*/(0, _react.memo)(ThumbnailAssetSelector);

exports.default = _default;